import { Link } from "react-router-dom";
import { CONTACT } from "@/data/content";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="bg-brand-ink text-white">
    <div className="mx-auto max-w-6xl px-6 py-16 md:py-20 lg:px-8">
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-6">
          <Logo light className="h-10 w-auto md:h-12" />
        </div>

        <div className="md:col-span-3">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-white/45">Kontakt</p>
          <div className="flex flex-col gap-2">
            <a
              href={CONTACT.emailHref}
              className="w-fit text-white/90 transition-colors hover:text-brand-blue-soft"
              data-testid="footer-email"
            >
              {CONTACT.email}
            </a>
            <a
              href={CONTACT.phoneHref}
              className="w-fit text-white/90 transition-colors hover:text-brand-blue-soft"
              data-testid="footer-phone"
            >
              {CONTACT.phone}
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-white/45">Mer</p>
          <div className="flex flex-col gap-2">
            <Link
              to="/integritetspolicy"
              className="w-fit text-white/90 transition-colors hover:text-brand-blue-soft"
              data-testid="footer-privacy"
            >
              Integritetspolicy
            </Link>
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-white/45">© {new Date().getFullYear()} IC Identity AB</p>
        <p className="text-xs text-white/45">
          Hemsida skapad av{" "}
          <a
            href="https://elido.nu/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white underline-offset-4 transition-colors hover:text-brand-blue-soft hover:underline"
            data-testid="footer-elido"
          >
            Elido
          </a>
        </p>
      </div>
    </div>
  </footer>
);
